export default "__VITE_ASSET__fc72ac3d__"